


















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import dayjs from 'dayjs';

@Component
export default class FormItem extends Vue {
  @Prop({default: ''}) readonly value!: number;
  @Prop({required: true}) fieldName!: string;
  @Prop() placeholder?: string;
  @Prop() type?: string;

  onValueChange(value: string) {
    this.$emit('update:value', value);
  }
  x(isoString: string){
    return dayjs(isoString).format('YYYY-MM-DD')
  }
}
